export type Cycle = "monthly" | "yearly" | "unknown";

export type SubscriberRow = {
  user_id: string;
  email: string | null;
  username: string | null;
  display_name: string | null;
  account_tier: string | null;
  cycle: Cycle;
  status: string;
  cancel_at_period_end: boolean;
  current_period_end: string | null;
  joined_at: string | null;
  unit_amount_cents: number;
  currency: string;
  mrr_cents: number;
  price_id: string;
  stripe_subscription_id: string;
  lookup_key: string | null;
};

export type SubscriberPayload = {
  environment: "sandbox" | "live";
  generated_at: string;
  rows: SubscriberRow[];
};

export type SortKey =
  | "email"
  | "tier"
  | "cycle"
  | "status"
  | "current_period_end"
  | "mrr_cents"
  | "joined_at";

export const TIER_LABEL: Record<string, string> = {
  starter: "Starter",
  plus: "Plus",
  pro: "Pro",
  elite: "Elite",
  agency: "Agency",
  comp: "Comp",
  admin_workspace: "Admin",
};

export const STATUS_TONE: Record<string, string> = {
  active: "bg-primary/10 text-primary",
  trialing: "bg-accent/30 text-foreground",
  past_due: "bg-destructive/15 text-destructive",
  canceled: "bg-muted text-muted-foreground",
  incomplete: "bg-muted text-muted-foreground",
  incomplete_expired: "bg-muted text-muted-foreground",
  unpaid: "bg-destructive/15 text-destructive",
  paused: "bg-muted text-muted-foreground",
};

export const PAGE_SIZE = 50;

export const fmtUsd = (cents: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(cents / 100);

export const fmtDate = (iso: string | null) => {
  if (!iso) return "—";
  return new Date(iso).toISOString().slice(0, 10);
};
